import React from "react";
import { Route, Routes, useLocation, matchPath, useSearchParams, Navigate } from "react-router-dom";
import { useState, useEffect, useCallback, createContext } from "react";
import axios from "axios";
// import ReactGA from "react-ga";
import ReactGAv4 from "react-ga4";
import SglContext from "./SglContext";
import { useNavigate } from 'react-router-dom';
import "./SglApp.css";
// import "./common/sgl-customizer.css";
import SglSidebar from "./common/SglSidebar";
import SglActions from "./common/SglActions";
import { LogOutRoute } from "./common/SglActions";
import SglShowPicker from "./common/SglShowPicker";
import ForgotPasswordForm from "./forgotPasswordForm/forgotPasswordForm";
import BadEmailForm from "./badEmailForm/badEmailForm";
import BadEmailVerificationForm from "./badEmailForm/badEmailVerificationForm";
import PasswordVerificationForm from "./forgotPasswordForm/passwordVerificationForm";
import UpdatePasswordForm from "./loginForm/updatePasswordForm";
import People from "./people/people";
import PeopleDetail from "./people/peopledetail";
import Classes from "./classes/classes";
import ClassDetail from "./classes/classdetail";
import Entries from "./entries/entries";
import EntryDetail from "./entries/entrydetail"
import ShowChampions from "./results/showChampions";
import DailyResults from "./results/dailyResults";
import ResultList from "../src/results/resultsList";
import Videos from '../src/videos/videos';
import VideoDetail from '../src/videos/videodetail';
import Subscription from '../src/videos/subscription';
import Schedule from "./schedule/schedule";
import MySchedule from "./schedule/mySchedule";
import RingStatus from "./ringStatus/ringStatusList";
import RingDetail from "./ringStatus/ringStatusDetail";
import SpecialStreaming from "./liveStreaming/SpecialStreaming";
import AllLiveStream from "./liveStreaming/alllivestreams";
import LivestreamDetails from "./liveStreaming/liveStreamDetails";
import MyEntries from "./entries/myentriesPage";

import MyAccount from "./actions/myAccount";
import Loginform from "./loginForm/loginForm";
import ConfirmEmail from "./loginForm/confirmEmail";
import VerifyMobileForm from "./loginForm/verifyMobileForm"
import RegistrationForm from "./registrationForm/registrationForm";
import RegistrationConfirmation from "./registrationForm/registrationConfirmation";
import md5 from "md5";
import CircuitStanding from "./results/circuitStanding";
import CircuitStandingDetail from "./results/circuitStandingsDetail";
import CircuitPointsDetail from "./results/circuitPointsDetail";
import MyResults from "./results/myResults";
import AddEntry from "../src/actions/addEntry";
import LiveChannels from "./channels/livestream";
import LivestremDetail from "./channels/livestreamDetail";
import AddDropClass from "../src/actions/addDropClass";
import ResultDetail from "./results/resultsDetail";
import AddDropTrainer from "../src/actions/addDropTrainer";
import DigitalSignature from "./actions/digitalSignatures"
import ClassSignup from "./classSignups/classSignupsList";
import ClassSignupDetail from "./classSignups/classSignupsDetail";
import ClassSignupIndex from "./classSignups/classSignupsIndex";
import AddOrderSupplies from "../src/actions/addOrderSupplies";
import LiveClassList from "./liveclass/liveclass";
import LiveClassDetail from "./liveclass/detail";
import Checkout from "../src/actions/checkout";
import OnDemand from "./channels/onDemand";
import OnDemandDetail from "./channels/onDemandDetail";
import { isMobile } from 'react-device-detect'
import LiveClassWidgetMobile from "./common/liveClassWidgetMobile";
import EditEntry from "../src/entries/editEntry";
import AddBankAccount from "./common/addBankAccount";
import LoginVerification from "./common/loginVerification"
// import AcceptInvite from "./actions/acceptInvite";
import AcceptRequest from "./actions/acceptRequest";
import BillingMessages from "./common/BillingMessages";
import { LoadingSpinner } from "./actions/teamManagement/utilities";
import NewOrderSupplies from "../src/actions/newOrderSupplies";
import PlatformFeeSetup from "./actions/platformFeeSetup";


function checkSupplyOrderingSwitch(switches) {
  if (!switches || !switches.switches) {
    return false;
  }
  
  const supplySwitch = switches.switches.find(
    switchItem => switchItem.switch_name === 'Supply Ordering Commerce System'
  );

  return supplySwitch && supplySwitch.value == 1;
}

function ScrollToTop({ company_id }) {
  const { pathname } = useLocation();

  useEffect(() => {
    let interval = null;
    
    if (company_id == 15) {
      const checkAndScroll = () => {
        const sglRoot = document.getElementById('sgl-root');
        // Check if element exists
        if (sglRoot && sglRoot.offsetHeight > 50) {
          const header = document.querySelector('header');
          const headerHeight = header ? header.offsetHeight : 0;
          
          // Get the position of sgl-root
          const elementPosition = sglRoot.getBoundingClientRect().top + window.pageYOffset;
          
          // Scroll to position minus header height
          window.scrollTo({
            top: elementPosition - headerHeight - 50,
            behavior: 'smooth'
          });
          
          return true;
        }
        return false;
      };
      
      // Try immediately
      if (!checkAndScroll()) {
        // If content not ready, keep trying
        let attempts = 0;
        interval = setInterval(() => {
          attempts++;
          if (checkAndScroll() || attempts >= 20) {
            clearInterval(interval);
            interval = null;
          }
        }, 200);
      }
    } else {
      window.scrollTo(0, 0);
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical !== null) {
      canonical.href = window.location.href;
    }
    
    // Cleanup function - guarantees interval is cleared
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [pathname]);
  
  return null;
}

function NavigateToWatch() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.location = pathname
  }, []);

  return null;
}

function WordPressContent({ content }) {
  return (
    <div 
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}

function SglApp(props) {
  const [searchParams, setSearchParams] = useSearchParams()
  const [loading, setLoading] = useState(true);
  const [current_user, setCurrentUser] = useState(false);
  const [currentShow, setCurrentShow] = useState(0);
  const [key, setKey] = useState("");
  const [login_id, setLoginId] = useState("");
  const [company_id, setCompanyId] = useState("");
  const [company_name, setCompanyName] = useState("");
  const [company_urlpath, setCompanyUrlPath] = useState("");
  const [ga_tracking_id, setGaTrackingId] = useState("UA-676768-4");
  const [ga_tracking_id_v4, setGaTrackingIdv4] = useState("G-J4VWS1KD5R");
  const [ga_video_tracking_id, setGaVideoTrackingId] = useState("G-CLZYEE5BZJ");
  const [license, setLicense] = useState(props.license);
  const [switches, setSwitches] = useState({ "switches": [] });
  const [basePath, setBasePath] = useState(props.base_path ? props.base_path : "");
  const [hide_mobile_nav, setHideMobileNav] = useState(props.hide_mobile_nav ? props.hide_mobile_nav : false);
  const [hide_admin_functions, setHideAdminFunctions] = useState(true);   
  const [is_mobile, setMobile] = useState(isMobile);
  const navigate = useNavigate();
  const [ip_address, setIP] = useState('');
  const [exists_live_classes, setExistsLiveClasses] = useState(false);
  const [pendingVerifyUserAction, setPendingVerifyUserAction] = useState(null);
  const [verification_status, setVerificationStatus] = useState(
    localStorage.getItem("verification_status") || ""
  );
  const { pathname } = useLocation();
  // const [currentTeamId, setCurrentTeamId] = useState(localStorage.getItem('currentTeamId') || 0);
  const [userTeams, setUserTeams] = useState(localStorage.getItem('userTeams') || []);
  const [currentTeamId, setCurrentTeamId] = useState(
  () => {
    const storedTeamId = localStorage.getItem('currentTeamId');
    const myTeams = localStorage.getItem('userTeams');
    if (myTeams) {
      try {
        const teams = JSON.parse(myTeams);

        const selectedTeam = teams?.find(team => team.teamId === storedTeamId || team.teamId == storedTeamId);
        if (selectedTeam) return storedTeamId;

        const ownerTeam = teams.find(team => team.isOwner === true);
        if (ownerTeam) return ownerTeam.teamId;
      } catch (err) {
        console.error("Error parsing userTeams:", err);
      }
    }

    return 0;
  });
  const [pendingRequestsCount, setPendingRequestsCount] = useState(0);
  const [hasUnsignedAgreements, setHasUnsignedAgreements] = useState(false);
  const [unsignedAgreements, setUnsignedAgreements] = useState([]);
  const [hasDefaultPaymentMethod, setHasDefaultPaymentMethod] = useState(true);
  const [isOnboardingMilestoneEnabled, setIsOnboardingMilestoneEnabled] = useState(false);
  const [loadingBillingData, setLoadingBillingData] = useState(false);
  const [switchesLoaded, setSwitchesLoaded] = useState(false);
  const [verificationPendingForTos, setVerificationPendingForTos] = useState(false)
  const [pendingAgreementsCount, setPendingAgreementsCount] = useState(0);
  const [fetchBillingData, setFetchBillingData] = useState(false)
  const [pendingUserOnboardAction, setPendingUserOnboardAction] = useState(null)
  const [homePageContent, setHomePageContent] = useState(() => {
    if (props.license && props.license.home_page_content) {
      try {
        return atob(props.license.home_page_content);
      } catch (error) {
        console.error('Error decoding home page content:', error);
        return '';
      }
    }
    return '';
  });

  // Extract API URLs from props with fallbacks
  const nestApiUrl = props.nest_api_url || process.env.REACT_APP_NEST_API;
  const sglApiUrl = props.sgl_api_url || process.env.REACT_APP_SGL_API;
  const sgl_desktop_sidebar = props.sgl_desktop_sidebar;
  const sgl_mobile_menu = props.sgl_mobile_menu;
  const adminDomain = process.env.REACT_APP_ADMIN_LINK + "/" + props.company_url_path;

  const [fb_pixel_id, setFbPixelId] = useState("");
  useEffect(() => {
    const styleId = 'sgl-sidebar-styles';
    const companyStyleId = 'sgl-company-styles';
    let existingStyle = document.getElementById(styleId);
    let existingCompanyStyle = document.getElementById(companyStyleId);
    
    // Original logic for hiding sidebar
    if (sgl_desktop_sidebar != 1 && !matchPath("/update-password", pathname)) {
      if (!existingStyle) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          .sgl-plugin-page .sgl-col-3 {
            display: none !important;
          }
        `;
        document.head.appendChild(style);
      }
    } else {
      if (existingStyle) {
        existingStyle.remove();
      }
    }

    // Separate style for company_id == -1
    if (company_id == -1) {
      if (!existingCompanyStyle) {
        const companyStyle = document.createElement('style');
        companyStyle.id = companyStyleId;
        companyStyle.textContent = `
          .sgl-plugin-page .sgl-col-9 {
            max-width: 100% !important;
            flex-basis: 100% !important;
          }

          .sgl-plugin-page #sgl-content-wrapper{
            max-width:100% !important;
          }

          .sgl-plugin-page #sgl-content-wrapper .loginformcss{
            margin:0px auto !important;
          }

          .sgl-plugin-page .sgl-content-wrapper .verifymobile .div-responsive{
            width:100% !important;
          }

          .sgl-plugin-page .sgl-col-3{
            display:none !important;
          }
        `;
        document.head.appendChild(companyStyle);
      }
    } else {
      if (existingCompanyStyle) {
        existingCompanyStyle.remove();
      }
    }

    // Cleanup function
    return () => {
      const styleToRemove = document.getElementById(styleId);
      const companyStyleToRemove = document.getElementById(companyStyleId);
      if (styleToRemove) {
        styleToRemove.remove();
      }
      if (companyStyleToRemove) {
        companyStyleToRemove.remove();
      }
    };
  }, [sgl_desktop_sidebar, company_id]);

  // Update team in local storage
  useEffect(() => {
    const storedTeamId = localStorage.getItem('currentTeamId');
    if (storedTeamId && storedTeamId !== currentTeamId) {
      localStorage.setItem('currentTeamId', currentTeamId)
    }
  }, [currentTeamId]);

  useEffect(() => {
    if (verification_status !== null) {
      localStorage.setItem("verification_status", verification_status);
    }
  }, [verification_status]);

  useEffect(() => {
    if (!process.env.REACT_APP_NEWRELIC_ENABLED) {
      return false
    }
    const script = document.createElement('script');
  
    script.src = process.env.PUBLIC_URL + "/newrelic.js";
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    }
  }, []);
  
  useEffect(() => {


    window.navigateSGL = navigate;
    let redirect_to_login = false;
    window.api_base_url = nestApiUrl
    axios.defaults.baseURL = nestApiUrl
    axios.defaults.withCredentials = true;
    axios.defaults.headers.common['SGL-REQUEST-ORIGIN'] = 'SGL-API';
    axios.defaults.headers.common['Cache-Control'] = 'no-cache';
    axios.defaults.headers.common['Pragma'] = 'no-cache';
    axios.defaults.headers.common['Expires'] = '0';
    axios.interceptors.request.use(function (config) {

      let token = localStorage.getItem("access_token")
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }else{
        setHideAdminFunctions(true)
      }
      var login_url = window.api_base_url + "/auth/login";
      if (config.url === login_url) {
        redirect_to_login = false;
      } else {
        redirect_to_login = true;
      }
      return config;
    }, function (error) {
      return Promise.reject(error);
    });

    axios.interceptors.response.use(response => {
      return response;
    }, error => {
      let json_data = error.toJSON();
      if (json_data.status !== 401) {
      }

      if (error.response && error.response.data) {
        if (error.response.data.statusCode === 401 && redirect_to_login) {
          if (window.location.pathname.indexOf('/login') == -1) {
             window.referrer = window.location.pathname.replace(basePath, '') + window.location.search + window.location.hash;
          }
          navigate("/login");
        }
      }
      return Promise.reject(error);
    });

  }, []);

  function reportToGA(path) {
    // ReactGA.pageview(path);
    ReactGAv4.send({ hitType: "pageview", page: path })
  }

  const reportToFB = useCallback((path, eventName = 'pageview') => { 
      if (window.fbq && fb_pixel_id && fb_pixel_id.trim() !== '') {
          window.fbq('track', eventName, {
              page: path
          });
      } 
  }, [fb_pixel_id]);

  function logWPPluginError() { }

  function logWPPlugin() { }

  function fetchMyEntriesData() { }

  function checkLoginOnSGL() {
    let currenttime = Date.now();
    let hash = md5("IphoneWebserviceApi" + currenttime + "SGL");
    axios
      .post(
        sglApiUrl + "/iphone.php/webservice/IsLoggedIn",
        {
          from_wp_api: true,
        },
        { headers: { "Content-Type": "application/json" } }
      )
      .then((res) => {
        if (!res.data.success) {
          loginOnSGL2();
        }
      });
  }

  function loginOnSGL(remember_me = false , update_password = false, verify_login=false, response_verification_status = "", pendingVerifyUserAction = null, pendingUserOnboardAction = null) {
    let currenttime = Date.now();
    let hash = md5("IphoneWebserviceApi" + currenttime + "SGL");
    axios
      .post(
        sglApiUrl +
        "/iphone.php/" +
        company_urlpath +
        "/webservice/AuthenticateUserViaJWT",
        {
          token: localStorage.getItem("access_token"),
          datetimestamp: currenttime,
          hash: hash,
          customer_id: company_id,
          from_wp_api: true,
          remember_me: remember_me,
        },
        { headers: { "Content-Type": "application/json" } }
      )
      .then((res) => {
        var ref_url;
        getUser()
        if (window.referrer != "") {
          // ref_url = new URL(window.referrer);
        }
        
        if (
          localStorage.getItem("playing_video_id") &&
          window.referrer != "" &&
          localStorage.getItem("playing_video_url") == window.referrer
        ) {
          navigate(window.referrer);
        } else if (pendingVerifyUserAction?.hasPendingAction) {
          if (response_verification_status == "unverified") {
            navigate('/verify-login')
          } else if (verification_status && verification_status == "unverified") {
            navigate('/verify-login')
          } else if (verify_login) {
            navigate('/verify-login')
          } else if (
            pendingUserOnboardAction?.hasPendingAction &&
            (!pendingUserOnboardAction?.defaultPaymentMethod || !pendingUserOnboardAction?.hasSignedTOS)
          ) {
            navigate('/platform-fee-setup')
          }
        } else if (
          pendingUserOnboardAction?.hasPendingAction &&
          (!pendingUserOnboardAction?.defaultPaymentMethod || !pendingUserOnboardAction?.hasSignedTOS)
        ) {
          navigate('/platform-fee-setup')
        } else if (update_password) {
          navigate('/update-password')
        } else if (res.data.verify_mobile_url != "") {
          navigate(res.data.verify_mobile_url)
        } else if (
          window.referrer &&
          window.referrer != "" &&
          window.referrer !=
          "https://" +
          window.location.hostname +
          "/forgot-password?forgot_password=1"
        ) {
          navigate(window.referrer);
        } else {
          if(company_id == -1){
            navigate('/edit-account')
          }else{
            navigate('/')
          }
        }
      });
  }

  function loginOnSGL2() {
    let currenttime = Date.now();
    let hash = md5("IphoneWebserviceApi" + currenttime + "SGL");

    axios
      .post(
        sglApiUrl +
        "/iphone.php/" +
        company_urlpath +
        "/webservice/AuthenticateUserViaJWT",
        {
          token: localStorage.getItem("access_token"),
          datetimestamp: currenttime,
          hash: hash,
          from_wp_api: true,
          check_already_logged_in: true,
        },
        { headers: { "Content-Type": "application/json" } }
      )
      .then((res) => {
        if (res.data.is_login_done) {
          window.location.reload();
        } else {
          if (!res.data.success) {
            axios.get(nestApiUrl + "/auth/logout").then(
              (response) => {
                if (response.data.logout) {
                  LogoutSGLSession();
                }
              },
              (error) => { }
            );
          }
        }
      });
  }

  function LogoutSGLSession() {
    axios
      .post(
        sglApiUrl +
        "/iphone.php/webservice/LogoutSGLAPIUser",
        {},
        { headers: { "Content-Type": "application/json" } }
      )
      .then((res) => {
        localStorage.removeItem("user_display_name");
        localStorage.removeItem("user_email");
        localStorage.removeItem("user_id");
        localStorage.removeItem("access_token");
        setHideAdminFunctions(true)
        window.location.reload();
      });
  }

  function getUser() {
    axios.get(nestApiUrl + "/users/getUser").then(
      (response) => {
        if (response.data.user && response.data.user != null) {
          var user_display_name =
            response.data.user.first + " " + response.data.user.last_name;
          var user_email = response.data.user.email_address;
          if (
            JSON.stringify(response.data.user) !== JSON.stringify(current_user)
          ) {
            response.data.user.userVerfied = response.data.userVerfied; 
            setCurrentUser(response.data.user);
            setLoginId(response.data.user.sgl_id)
          }
          if(response.data.user.sgl_id != "" && company_id != ""){
            axios.get(sglApiUrl + '/iphone.php/content/CheckUserAccessForAdminFunction',{
              params : {
                  customer_id: company_id,
                  user_id: response.data.user.sgl_id
              }
            }).then(res => {
                if(res.data.success==true){
                  setHideAdminFunctions(false)
                }
                else{
                  setHideAdminFunctions(true)
                }
            });
          }
          localStorage.setItem("user_display_name", user_display_name);
          localStorage.setItem("user_email", user_email);
          localStorage.setItem("userTeams", JSON.stringify(response.data.userTeams));
          const currentTeamId = localStorage.getItem("currentTeamId")
          const ownedTeam = response.data.userTeams?.find(team => team.isOwner);
          const selectedTeam = response.data.userTeams?.find(team => team.teamId === currentTeamId || team.teamId == currentTeamId);
          setCurrentTeamId(selectedTeam?.teamId || ownedTeam?.teamId || 'personal');
          setUserTeams(response.data.userTeams)

          setLoading(false);
        } else if ( searchParams.get('flogin') != null && searchParams.get('flid') != null) {
          axios.post(
            nestApiUrl + "/auth/flogin",
            {
              username: searchParams.get('flid'),
              password: searchParams.get('flogin'),
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
            ).then(
              (response) => {
                debugger
                localStorage.setItem("access_token", response.data.access_token);
                localStorage.setItem("username", response.data.user.email_address);
                loginOnSGL2('no');
                setLoading(false);
              },
              (error) => {
                setCurrentUser(false);
                setLoading(false);
              }
            )
        }
        else {
          setCurrentUser(false);
          setLoading(false);
        }
      },
      (error) => {
        setCurrentUser(false);
        setLoading(false);
      }
    );
  }

  const fetchPendingRequestsCount = async () => {
    if (!current_user) {
      setPendingRequestsCount(0);
      return;
    }
    
    try {
      const response = await axios.get(`${nestApiUrl}/user-requests/pending`);
      setPendingRequestsCount(response.data.length);
    } catch (error) {
      console.error('Error fetching pending requests count:', error);
      setPendingRequestsCount(0);
    }
  };

  const refreshPendingRequestsCount = async() => {
    await fetchPendingRequestsCount();
  };

      const fetchPendingAgreementsCount = async () => {
    if (!current_user) {
      setPendingAgreementsCount(0);
      return;
    }
    
    try {
      const response = await axios.get(`${nestApiUrl}/billing/getUnsignAgreementsForUser`, {
        params: { 
          login_id: current_user.sgl_id, 
          company_id: company_id 
        }
      });
      const count = response.data.unSignedAgreements?.length || 0;
      setPendingAgreementsCount(count);
    } catch (error) {
      console.error('Error fetching pending agreements count:', error);
      setPendingAgreementsCount(0);
    }
  };

  const refreshPendingAgreementsCount = () => {
    fetchPendingAgreementsCount();
  };

  const updateCountForMyAccount = async() => {
    await Promise.all([
      fetchPendingRequestsCount(),
      fetchPendingAgreementsCount()
    ])
  }

  useEffect(() => {
    if (current_user && current_user.sgl_id) {
      updateCountForMyAccount()
    } else {
      setPendingRequestsCount(0);
      setPendingAgreementsCount(0);
    }
  }, [current_user, unsignedAgreements]);


  useEffect(() => {
    axios.get(nestApiUrl + "/users/getUser").then(
      (response) => {
        if (response.data.user && response.data.user != null) {
          if(response.data.user.sgl_id != "" && company_id != ""){
            axios.get(sglApiUrl + '/iphone.php/content/CheckUserAccessForAdminFunction',{
              params : {
                  customer_id: company_id,
                  user_id: response.data.user.sgl_id
              }
            }).then(res => {
                if(res.data.success==true){
                  setHideAdminFunctions(false)
                }
                else{
                  setHideAdminFunctions(true)
                }
            });
          }
        }
      },
    );
  },[company_id])

  useEffect(() => {
    axios
      .get(
        sglApiUrl +
        "/iphone.php/webservice/VerifyWPLicense",
        {
          params: {
            company_id: license.company_id,
            license_key: license.key,
            from_wp_api: true,
          },
        }
      )
      .then((res) => {
        setLicense(res.data);
        setCompanyId(res.data.company.id);
        setCompanyName(res.data.company.name);
        setCompanyUrlPath(res.data.company.urlpath);
        // setIsNewBillingModalEnabled(true);
        const pixelId = license.fb_pixel_id;
        setFbPixelId(pixelId);
        // ReactGA.initialize(ga_tracking_id);
        ReactGAv4.initialize([
          {
            trackingId: ga_tracking_id_v4, 
            gtagOptions: {
              send_page_view : false
            },
            gaOptions: {
              name: 'SGL-V4',
            }
          },
          {
            trackingId: ga_tracking_id, 
            gtagOptions: {
              send_page_view : false
            },
            gaOptions: {
              name: 'SGL-UA',
            }
          },
          ...(license.ga_tracking_id && license.ga_tracking_id.trim() != '' ? [{
            trackingId: license.ga_tracking_id,
            gtagOptions: {
              send_page_view: false
            },
            gaOptions: {
              name: 'SGL-Company-ID',
            }
          }] : [])
        ])

        if (license.fb_pixel_id && license.fb_pixel_id.trim() != '' && !window.fbq) {
          (function(f,b,e,v,n,t,s) {
            if(f.fbq) return;
            n=f.fbq=function(){
              n.callMethod ? n.callMethod.apply(n,arguments) : n.queue.push(arguments)
            };
            if(!f._fbq) f._fbq=n;
            n.push=n; n.loaded=!0; n.version='2.0';
            n.queue=[]; t=b.createElement(e); t.async=!0;
            t.src=v; s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)
          })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
          
          // window.fbq('init', license.fb_pixel_id);
          window.fbq('init', pixelId);
          window.fbq('track', 'PageView');
        }

        getUser();
        document.body.classList.add('sgl-plugin-page');
      });
  }, [props.license]);


  useEffect(() => {
    axios
      .get(
        nestApiUrl +
        "/homepage/getCompanySwitches",
        {
          params: {
            customer_id: license.company_id,
            company_id: company_id

          },
        }
      )
      .then((res) => {
        setSwitches(res.data ? res.data : { "switches": [] });
        setSwitchesLoaded(true);
      });
  }, [props.license]);

  // useEffect(() => {
  //   fetch(
  //     "https://geolocation-db.com/json/0f761a30-fe14-11e9-b59f-e53803842572"
  //   )
  //     .then(response => response.json())
  //     .then(data => setIP(data.IPv4));
  // }, []);
  useEffect(() => {
    if ( company_id ) {
      checkLiveClasses();
    }
  }, [company_id])

  // get the unsign agreement ackowledgements and default payment methods
  // const getBillingData = async() => {
    
  //   if(!login_id || login_id <= 0 || !company_id || company_id <= 0 || !isNewBillingModalEnabled){
  //     setHasUnsignedAgreements(false)
  //     setUnsignedAgreements([])
  //     setHasDefaultPaymentMethod(true);
  //     setVerificationPendingForTos(false)
  //     return; // get the billing if there is some logged in user and SMC
  //   }

  //   try {
  //     setLoadingBillingData(true)
  //     const res = await axios.get(nestApiUrl + "/billing/getBillingDataForSglActions", {
  //       params: { login_id, company_id }
  //     })

  //     if (res?.data?.success) {
  //       const _unSignedAgreements = res.data.agreements ?? [];
  //       setHasUnsignedAgreements(res.data.hasUnsignedAck ?? false);
  //       setUnsignedAgreements(_unSignedAgreements);
  //       setVerificationPendingForTos(res.data.verificationPending)
  //       setHasDefaultPaymentMethod(res.data.hasDefaultPaymentMethod ?? false);
  //     }

  //     setLoadingBillingData(false)
  //   } catch (err) {
  //     console.error("Error fetching billing data:", err);
  //     setLoadingBillingData(false)
  //   }

  // }

  const getPendingUserActions = async() => {
      if(!login_id || login_id <= 0 || !company_id || company_id <= 0 || loadingBillingData){
      return; // get the billing if there is some logged in user and SMC
    }

    const get_pending_verify_user_action =  nestApiUrl + "/milestone-actions/getPendingVerifyUserAction";
    const get_pending_onboard_user_action =  nestApiUrl + "/milestone-actions/getPendingOnBoardUserAction";

    setLoadingBillingData(true)
    const [verifyUserAction, onBoardUserAction] = await Promise.all([
      axios.get(get_pending_verify_user_action, {
        params: { user_id: login_id, customer_id: company_id }
      }),

      axios.get(get_pending_onboard_user_action, {
        params: { user_id: login_id, customer_id: company_id }
      })

    ])

    setPendingVerifyUserAction(verifyUserAction?.data ?? null)
    setPendingUserOnboardAction(onBoardUserAction?.data ?? null) 
    setLoadingBillingData(false)
  }

  useEffect(() => {
    // getBillingData()
    getPendingUserActions()
  }, [login_id, company_id, fetchBillingData])

  const checkOnboardingMilestone = useCallback(async () => {
    if (!company_id || company_id <= 0) {
      return false;
    }

    try {
      const response = await axios.get(`${nestApiUrl}/billing/checkCompanyMilestone`, {
        params: {
          company_id: company_id,
          milestone_code: 'ONBOARDED_USER'
        }
      });
      
      console.log('Onboarding milestone check:', response.data);
      setIsOnboardingMilestoneEnabled(response.data.isEnabled || false);
      return response.data.isEnabled || false;
    } catch (error) {
      console.error('Error checking onboarding milestone:', error);
      setIsOnboardingMilestoneEnabled(false);
      return false;
    }
  }, [company_id, nestApiUrl]);

  useEffect(() => {
    if (company_id && company_id > 0) {
      checkOnboardingMilestone();
    }
  }, [company_id, checkOnboardingMilestone]);
  
  
  function checkLiveClasses() {
    let timestamp = Date.now();

    const webservice_liveclass_widget = nestApiUrl + "/homepage/getLiveClassStatus";
    axios.get(
      webservice_liveclass_widget,
      {
        params : {
          datetimestamp: timestamp,
          customer_id: company_id,
          }
      }
    )
    .then((res) => {
      if ( res.data ) {
        setExistsLiveClasses(true);
      } else {
        setExistsLiveClasses(false);
      }
    });
  };


  function onShowChange(show_id) {
    setCurrentShow(show_id);
  }

  const useNewOrderSupplies = switchesLoaded ? checkSupplyOrderingSwitch(switches) : false;

  if (loading) {
    return null;
  }


  return (
    <SglContext.Provider
      value={{
        company_id,
        company_name,
        company_urlpath,
        current_user,
        switches,
        basePath,
        is_mobile,
        currentTeamId, 
        userTeams,
        verification_status,
        pendingVerifyUserAction,
        setPendingVerifyUserAction,
        setVerificationStatus,
        setCurrentTeamId,
        setUserTeams,
        reportToGA,
        reportToFB,
        logWPPluginError,
        logWPPlugin,
        fetchMyEntriesData,
        checkLoginOnSGL,
        loginOnSGL,
        loginOnSGL2,
        LogoutSGLSession,
        getUser,
        ip_address,
        exists_live_classes,
        pendingRequestsCount,
        setPendingRequestsCount,
        refreshPendingRequestsCount,
        pendingAgreementsCount, 
        setPendingAgreementsCount, 
        refreshPendingAgreementsCount, 
        hasUnsignedAgreements, setHasUnsignedAgreements,
        unsignedAgreements, setUnsignedAgreements,
        hasDefaultPaymentMethod, setHasDefaultPaymentMethod, verificationPendingForTos,
        isOnboardingMilestoneEnabled, setIsOnboardingMilestoneEnabled, checkOnboardingMilestone,
        nestApiUrl: nestApiUrl,
        sglApiUrl: sglApiUrl,
        adminDomain: adminDomain,
        fetchBillingData, setFetchBillingData,
        hasDefaultPaymentMethod, setHasDefaultPaymentMethod, verificationPendingForTos,
        pendingUserOnboardAction, setPendingUserOnboardAction, getPendingUserActions,
        ga_video_tracking_id
      }}>
      <ScrollToTop company_id={company_id} />
      <div className='sgl-row'>
        {
          ( !matchPath("/update-password", pathname))?<SglSidebar currentShow={currentShow} hide_mobile_nav={hide_mobile_nav} hide_admin_functions={hide_admin_functions} sgl_desktop_sidebar={sgl_desktop_sidebar} sgl_mobile_menu={sgl_mobile_menu} company_id={company_id} />:<div className='sgl-col-3'></div>
        }
        
        <div className={`sgl-col-9 ${pathname.includes('edit-account') ? 'my-account-container' : ''}`}>
          <div className='sgl-plugin'>
            {
              (!matchPath("/update-password", pathname) && company_id != -1) ?
              <>
              <SglActions basePath={basePath} />
              <SglShowPicker onShowChange={onShowChange} />
              
              {
                // Display Pending Agreements and Default Payment Method Messages for Add Entry, Class Add/drop, Order Supplies, Checkout Entries
                (
                  // (hasUnsignedAgreements || !hasDefaultPaymentMethod || verificationPendingForTos) &&
                  (
                    pathname.includes('add-entry') ||
                    pathname.includes('class-adds-drops') ||
                    pathname.includes('order-supplies') ||
                    pathname.includes('checkout-entries')
                  )
                ) ?
                (pendingUserOnboardAction?.hasPendingAction && pendingVerifyUserAction?.hasPendingAction && verification_status && verification_status == "unverified") 
                ? navigate('/verify-login')
                : pendingUserOnboardAction?.hasPendingAction && !pendingVerifyUserAction?.hasPendingAction && verification_status && verification_status != "unverified" ? 
                navigate('/platform-fee-setup') : null
                : null
              }
              <LiveClassWidgetMobile />
              </>
              :
              (company_id == -1) ?
              <>
                <SglActions basePath={basePath} company_id={company_id} />
              </>
              : ""
            }
            <div id='sgl-content-wrapper' className="sgl-content-wrapper">
              {(!license.status || license.status !== "activated") && (
                <div>This content is not available at the moment.</div>
              )}
              {license && license.status === "activated" && (
                <Routes>
                  <Route
                    path='/'
                    element={
                      <>
                        {company_id == 15 || company_id == 51 ? (
                          <>
                            <h1>Welcome to ShowGroundsLive!</h1>
                            <br/>

                            <Schedule
                              homepageschedule={true}
                              current_show={localStorage.getItem('default_show_id')}
                            />
                          </>
                        ) : (
                          homePageContent && (
                            <WordPressContent content={homePageContent} />
                          )
                        )}
                      </>
                    }></Route>
                  <Route
                    path='/showgroundslive-home'
                    element={
                      <>
                        {company_id == 15 || company_id == 51 ? (
                          <>
                            <h1>Welcome to ShowGroundsLive!</h1>
                            <br/>

                            <Schedule
                              homepageschedule={true}
                              current_show={localStorage.getItem('default_show_id')}
                            />
                          </>
                        ) : (
                          homePageContent && (
                            <WordPressContent content={homePageContent} />
                          )
                        )}
                      </>
                    }></Route>
                  <Route
                    path='/redirect'
                    element={<LogOutRoute />}></Route>
                  <Route
                    path="/watch*"
                    element={<NavigateToWatch/>}></Route>
                  <Route
                    path='/people'
                    element={
                      <People currentShow={currentShow} />
                    }>
                  </Route>

                  <Route path='/people/detail/' element={
                    <PeopleDetail/>
                  }>
                  </Route>

                  <Route path='/my-results/' element={
                    <MyResults  key={Date.now()}/>
                  }>
                  </Route>

                  <Route
                    path='/circuit-standings/'
                    element={
                      <CircuitStanding currentShow={currentShow}  key={Date.now()}/>
                    }>
                  </Route>

                  <Route path='/circuitstanding/detail/' element={
                    <CircuitStandingDetail  key={Date.now()}/>
                  }>
                  </Route>

                  <Route path='/circuitstanding/detail/points/' element={
                    <CircuitPointsDetail/>
                  }>
                  </Route>
                  <Route
                    path='/classes'
                    element={<Classes currentShow={currentShow}  key={Date.now()}/>}></Route>

                  <Route
                    path='/classes/detail'
                    element={<ClassDetail/>}></Route>

                  <Route
                    path='/horses-entries'
                    element={<Entries currentShow={currentShow}  key={Date.now()}/>}></Route>

                  <Route path='/entries/detail' element={<EntryDetail/>}> </Route>

                  <Route path='/live-channels/' element={<LiveChannels  key={Date.now()}/>}> </Route>

                  <Route path='/live-channels/detail/' element={<LivestremDetail  key={Date.now()}/>}> </Route>

                  <Route
                    path='/send-verification-email'
                    element={<BadEmailForm />}></Route>
                  <Route
                    path='/process-email-verification'
                    element={<BadEmailVerificationForm />}></Route>

                  <Route
                    path='/forgot-password'
                    element={<ForgotPasswordForm />}></Route>

                  <Route
                    path='/password-verification'
                    element={<PasswordVerificationForm />}></Route>

                  <Route path='/update-password' element={<UpdatePasswordForm />}></Route>

                  <Route path='/login' element={<Loginform />}></Route>
                  <Route path='/edit-account' element={<MyAccount />}></Route>
                  <Route
                    path='/confirm-email-change'
                    element={<ConfirmEmail />}></Route>

                  <Route
                    path='/registration'
                    element={<RegistrationForm />}></Route>

                  <Route
                    path='/regconfirmation'
                    element={<RegistrationConfirmation />}></Route>
                  <Route
                    path='/verify-mobile'
                    element={<VerifyMobileForm flid={login_id} company_id={company_id} />}></Route>
                  <Route
                    path='/verify-login'
                    element={
                      (verification_status == "unverified" || verification_status == "provisional")
                        ? <LoginVerification flid={login_id} company_id={company_id} />
                        : <Navigate to="/" />
                    }
                  />                  
                  {/* <Route
                    path='/accept-team-invite/:token'
                    element={<AcceptInvite/>}>
                  </Route> */}
                  <Route
                    path='/user-requests/:token'
                    element={<AcceptRequest/>}>
                  </Route>
                  <Route
                    path='/show-champions'
                    element={
                      <ShowChampions currentShow={currentShow}  key={Date.now()}/>
                    }></Route>

                  <Route
                    path='/daily-results'
                    element={
                      <DailyResults currentShow={currentShow}/>
                    }></Route>
                  <Route
                    path='/videos'
                    element={
                      <Videos currentShow={currentShow}/>
                    }>
                  </Route>
                  <Route
                    path='/videos/detail'
                    element={
                      <VideoDetail currentShow={currentShow}  key={Date.now()}/>
                    }>
                  </Route>

                  <Route
                    path='/videos/subscribe'
                    element={
                      <Subscription currentShow={currentShow}  key={Date.now()}/>
                    }>
                  </Route>

                  <Route
                    path="/browse"
                    element={
                      <ResultList

                        current_show={currentShow}
                        key={Date.now()}
                      />
                    }
                  ></Route>
                  <Route
                    path="/show-schedule"
                    element={
                      <Schedule
                        current_show={currentShow}
                      />
                    }
                  >
                  </Route>
                  <Route
                    path='/my-schedule'
                    element={
                      <MySchedule currentShow={currentShow} />
                    }>
                  </Route>
                  <Route
                    path='/add-entry'
                    element={loadingBillingData ? <LoadingSpinner messsage="Checking Billing Data..." /> : <AddEntry key={Date.now()} />}>
                  </Route>
                  <Route
                    path='/class-adds-drops'
                    element={loadingBillingData ? <LoadingSpinner messsage="Checking Billing Data..." /> : <AddDropClass current_show={currentShow} key={Date.now()} />}>
                  </Route>
                  <Route
                    path='/trainer-add-drop'
                    element={<AddDropTrainer current_show={currentShow} key={Date.now()} />}>
                  </Route>

                  <Route
                    path='/orders-of-go-signups'
                    element={<ClassSignup current_show={currentShow} />}>
                  </Route>

                  <Route
                    path='/classsignup/viewSetOrder'
                    element={<ClassSignupDetail current_show={currentShow}  key={Date.now()}/>}>
                  </Route>

                  <Route
                    path='/classsignup/index'
                    element={<ClassSignupIndex current_show={currentShow}  key={Date.now()}/>}>
                  </Route>

                  <Route
                    path='/order-supplies/complete-order'
                    element={
                      loadingBillingData ? (
                        <LoadingSpinner message="Checking Billing Data..." />
                      ) : !switchesLoaded ? (
                        <div>Loading...</div> // Show loading while switches load
                      ) : useNewOrderSupplies ? (
                        <NewOrderSupplies current_show={currentShow} key={Date.now()} />
                      ) : (
                        <AddOrderSupplies current_show={currentShow} key={Date.now()} />
                      )
                    }
                  />


                  <Route
                    path='/order-supplies'
                    element={
                      loadingBillingData ? (
                        <LoadingSpinner message="Checking Billing Data..." />
                      ) : !switchesLoaded ? (
                        <div>Loading...</div> // Show loading while switches load
                      ) : useNewOrderSupplies ? (
                        <NewOrderSupplies current_show={currentShow} key={Date.now()} />
                      ) : (
                        <AddOrderSupplies current_show={currentShow} key={Date.now()} />
                      )
                    }
                  />
                  <Route path='/ring-status' element={<RingStatus current_show={currentShow} />}></Route>
                  <Route path='/ring/detail' element={<RingDetail  key={Date.now()}/>}></Route>

                  <Route path='/special-events-live-streaming' element={<SpecialStreaming  key={Date.now()}/>}></Route>

                  <Route path='/results/detail' element={<ResultDetail/>}></Route>

                  <Route path='/digital-signature' element={<DigitalSignature  key={Date.now()}/>}> </Route>

                  <Route path='/livestream' element={<AllLiveStream  key={Date.now()}/>}> </Route>

                  <Route path='/livestream/detail' element={<LivestreamDetails  key={Date.now()}/>}> </Route>
                  <Route
                    path='/checkout-entries'
                    element={loadingBillingData ? <LoadingSpinner messsage="Checking Billing Data..." /> : <Checkout current_show={currentShow}  key={Date.now()}/>}>
                  </Route>

                  <Route path='/liveclass' element={<LiveClassList  key={Date.now()}/>}></Route>
                  <Route path='/liveclass/detail' element={<LiveClassDetail  key={Date.now()}/>}></Route>


                  <Route path="/demand-channels/" element={<OnDemand  key={Date.now()}/>}></Route>
                  <Route path="/demand-channels/detail" element={<OnDemandDetail  key={Date.now()}/>}></Route>

                  <Route path="/my-entries" element={<MyEntries currentShow={currentShow}  key={Date.now()}/>}></Route>
                  <Route
                    path='/edit-entry'
                    element={<EditEntry key={Date.now()} />}>
                  </Route>
                  <Route
                    path='/add-bank-account'
                    element={<AddBankAccount key={Date.now()} />}>
                  </Route>
                  <Route path="/platform-fee-setup/" element={<PlatformFeeSetup />} />
                </Routes>
              )}
            </div>
          </div>
        </div>
      </div>
    </SglContext.Provider>
  );
}

export default SglApp;
